import { Box, List, Text } from '@factorialco/deprecated-design-system'
import { ContractVersionsPageContractVersionCompensationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ContractData from 'modules/contracts/components/ContractDetails/Section/ContractData'

import CompensationItem from './CompensationItem'

interface Props {
  compensations: ContractVersionsPageContractVersionCompensationFragment[]
  legalEntityCurrency: string
}

const AdditionalCompensationsDeprecated = ({ compensations, legalEntityCurrency }: Props) => {
  const hasCompensations = compensations.length > 0

  return (
    <ContractData>
      <Box gap="s24">
        <Text size="200" weight="normal" color="grey800">
          {i18n.t('contract_versions.compensation.additional_compensations.title')}
        </Text>
        {hasCompensations ? (
          <List>
            <>
              {compensations.map((compensation) => {
                return (
                  <CompensationItem
                    key={`compensation-${compensation.id}`}
                    compensation={compensation}
                    legalEntityCurrency={legalEntityCurrency}
                  />
                )
              })}
            </>
          </List>
        ) : (
          <Text size="300" weight="medium" color="grey600">
            {i18n.t('contract_versions.compensation.not_informed')}
          </Text>
        )}
      </Box>
    </ContractData>
  )
}

export default AdditionalCompensationsDeprecated
